(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["template-faq"]) return;
  try {
    
//TODO: Toggle icons
$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
  $('a[role="tab"]').attr('aria-selected', 'false');
  $(e.target).attr('aria-selected', 'true');
});
$('.tab-panel').on('show.bs.collapse', function () {
	$(this).addClass('open');
});
$('.tab-panel').on('hide.bs.collapse', function () {
  $(this).removeClass('open');
});

  } catch(e) { console.error(e); }
})();
})();
